<!-- /components/modals/AddNewValue.vue -->
<template>
  <Modal @close="$emit('close')">
    <template v-slot:body>
      <!-- Usamos Vuetify para consistencia -->
      <v-text-field
        v-model="nuevoValor"
        label="Nuevo Nombre"
        placeholder="Ej: Colesterol Total"
        autofocus
        @keydown.enter="emitValor"
      ></v-text-field>
    </template>
    <template v-slot:footer>
      <v-btn color="primary" @click="emitValor" :disabled="!nuevoValor.trim()">Agregar</v-btn>
      <v-btn text @click="closeModal">Cancelar</v-btn>
    </template>
  </Modal>
</template>

<script>
// Asegúrate de que este componente 'Modal.vue' base exista y funcione.
// Si no lo tienes, puedes usar v-dialog de Vuetify directamente.
import Modal from './Modal.vue';

export default {
  name: 'AddNewValueModalFlotante', // Nombre consistente
  components: { Modal },
  data() {
    return {
      nuevoValor: ''
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    emitValor() {
      if (this.nuevoValor.trim() !== '') {
        // Emite el valor que el CrudComponent escuchará
        this.$emit('nuevo-valor', this.nuevoValor.trim());
        this.closeModal();
      }
    }
  }
};
</script>